import { useEffect, useState } from 'react';
import { getPaintInformed } from '../../services/sampling/sampling';


export const useRooms = () => {

    const [InformedConsent, setInformedConsent] = useState([])



    useEffect(() => {
        GetSettings()
    }, [])


    // ? CONFIGURATION INFORMED CONSENT REQUEST
    const GetSettings = async () => {
        const listInformed = await getPaintInformed();

        if (listInformed.data.length > 0) {
            const cloned = JSON.parse(JSON.stringify(listInformed.data));

            cloned.forEach((q, i) => {
                q.visibility = (i === 0);
            });

            setInformedConsent(cloned);
        }
        else {
            setInformedConsent([]);
        }
    };






    return {
        InformedConsent


    }
}
